import
{
    useModifySystemMaintenance,
    useSystem,
    useSystemMaintenance
} from "../../../ReactData/system";

import { DateTimeFormatMaintenanceReport, permissionAllowed, SystemMaintenanceReport, SystemType } from "@ews/react-data";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsTitle from "../../../Settings/SettingsTitle/SettingsTitle";
import { MaintenanceReportsSettingsProps } from "./types";
import { useMyPermissions } from "../../../Login/LoginProvider";

const MaintenanceReportsSettings: React.FC<MaintenanceReportsSettingsProps> = ({ systemId }) =>
{
    const system = useSystem(systemId);
    const maintenance = useSystemMaintenance(systemId);

    const modifySystemMaintenance = useModifySystemMaintenance();
    const myPermissions = useMyPermissions();
    const allowedToEdit = permissionAllowed(myPermissions.grantSystemAccess || 0);

    function saveSystemMaintenance(key: keyof SystemMaintenanceReport,
        value: any)
    {
        if (!system.id || !(key in maintenance)) return;
        maintenance[key] = value;
        modifySystemMaintenance(system.id,
            { [key]: value } as SystemMaintenanceReport);
    }

    function saveDateTimeFormat(current: number, format: number, checked: boolean)
    {
        const value = checked ? current | format : current ^ format;
        saveSystemMaintenance("dateTimeFormat", value);
    }

    return <>
        <SettingsCol >
            <SettingsTitle
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_TIMEFORMAT"}
                endText={':'} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_TIMEFORMAT_DAY"}
                checked={((maintenance.dateTimeFormat || 0) & DateTimeFormatMaintenanceReport.day) === DateTimeFormatMaintenanceReport.day}
                onChange={(checked) =>
                {
                    saveDateTimeFormat(maintenance.dateTimeFormat || 0, DateTimeFormatMaintenanceReport.day, checked);
                }} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_CONTENT_MONTH"}
                checked={((maintenance.dateTimeFormat || 0) & DateTimeFormatMaintenanceReport.month) === DateTimeFormatMaintenanceReport.month}
                onChange={(checked) =>
                {
                    saveDateTimeFormat(maintenance.dateTimeFormat || 0, DateTimeFormatMaintenanceReport.month, checked);
                }} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_LOGS_BALANCE_YEAR"}
                checked={((maintenance.dateTimeFormat || 0) & DateTimeFormatMaintenanceReport.year) === DateTimeFormatMaintenanceReport.year}
                onChange={(checked) =>
                {
                    saveDateTimeFormat(maintenance.dateTimeFormat || 0, DateTimeFormatMaintenanceReport.year, checked);
                }} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_TIMEFORMAT_HOUR"}
                checked={((maintenance.dateTimeFormat || 0) & DateTimeFormatMaintenanceReport.hour) === DateTimeFormatMaintenanceReport.hour}
                onChange={(checked) =>
                {
                    saveDateTimeFormat(maintenance.dateTimeFormat || 0, DateTimeFormatMaintenanceReport.hour, checked);
                }} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_TIMEFORMAT_MINUTE"}
                checked={((maintenance.dateTimeFormat || 0) & DateTimeFormatMaintenanceReport.minute) === DateTimeFormatMaintenanceReport.minute}
                onChange={(checked) =>
                {
                    saveDateTimeFormat(maintenance.dateTimeFormat || 0, DateTimeFormatMaintenanceReport.minute, checked);
                }} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_TIMEFORMAT_SECOND"}
                checked={((maintenance.dateTimeFormat || 0) & DateTimeFormatMaintenanceReport.second) === DateTimeFormatMaintenanceReport.second}
                onChange={(checked) =>
                {
                    saveDateTimeFormat(maintenance.dateTimeFormat || 0, DateTimeFormatMaintenanceReport.second, checked);
                }} />

        </SettingsCol>
        <SettingsCol >
            <SettingsTitle
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_EVENTFILTER"}
                endText={':'} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_EVENTFILTER_SE"}
                checked={maintenance.includeActuationDevices || false}
                onChange={(checked) => saveSystemMaintenance("includeActuationDevices", checked)} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_EVENTFILTER_AE"}
                checked={maintenance.includeAlarmingDevices || false}
                onChange={(checked) => saveSystemMaintenance("includeAlarmingDevices", checked)} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_EVENTFILTER_UE"}
                checked={maintenance.includeTransmittingDevices || false}
                onChange={(checked) => saveSystemMaintenance("includeTransmittingDevices", checked)} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_EVENTFILTER_ELEMENT_LEADINGZERO"}
                checked={maintenance.formatLeadingZeros || false}
                onChange={(checked) => saveSystemMaintenance("formatLeadingZeros", checked)} />

            {system.systemType === SystemType.BC600 ?
                <SettingsCheckbox
                    disabled={!allowedToEdit}
                    text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_EVENTFILTER_EVENT_TEXT"}
                    checked={maintenance.showEventText || false}
                    onChange={(checked) => saveSystemMaintenance("showEventText", checked)} />
                : null}
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_EVENTFILTER_SILENT_SYSIN"}
                checked={maintenance.includeSilentInputDevices || false}
                onChange={(checked) => saveSystemMaintenance("includeSilentInputDevices", checked)} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE_EVENTFILTER_SILENT_SYSOUT"}
                checked={maintenance.includeSilentOutputDevices || false}
                onChange={(checked) => saveSystemMaintenance("includeSilentOutputDevices", checked)} />

        </SettingsCol>
        <SettingsCol >
            <></>
        </SettingsCol>
    </>;
};

export default MaintenanceReportsSettings;